module.exports = __webpack_public_path__ + "img/word.4761391e.svg";